import StyledTypo from '@tmh-website/styles/typo';
import { FormElementThemeColor, formElementThemes } from '@tmh-website/ui/FormElements';
import styled, { css } from 'styled-components';

export const Label = styled.label<{ $themeColor: FormElementThemeColor; $isChecked: boolean }>`
  display: inline-flex;
  align-items: flex-start;
  color: ${props => props.theme.color[formElementThemes[props.$themeColor].text]};
  cursor: pointer;

  &:hover {
    input[type='radio'] {
      box-shadow: inset 0 0 0 2px ${props => props.theme.color[formElementThemes[props.$themeColor].border.hover]};

      ${props =>
        props.$isChecked &&
        css`
          &::after {
            background-color: ${props.theme.color[formElementThemes[props.$themeColor].checked.hover]};
          }
        `};
    }
  }
`;

export const RadioInput = styled.input<{ $themeColor: FormElementThemeColor; $isChecked: boolean }>`
  position: relative;
  z-index: 3;
  flex: 0 0 24px;
  width: 24px;
  height: 24px;
  padding: 0;
  margin: 0 8px 0 0;
  overflow: hidden;
  cursor: pointer;
  background: none;
  background-color: ${props => props.theme.color[formElementThemes[props.$themeColor].background.normal]};
  border-radius: ${({ theme }) => (theme.isBorderRadiusDisabled ? 0 : '99999px')};
  box-shadow: inset 0 0 0 2px ${props => props.theme.color[formElementThemes[props.$themeColor].border.normal]};
  transition: background-color ${props => props.theme.transitionTiming},
    box-shadow ${props => props.theme.transitionTiming};
  appearance: none;

  &::after,
  &::before {
    position: absolute;
    pointer-events: none;
    content: '';
    opacity: 0;
    transition: all 0.2s ease;
  }

  &::before {
    top: 0;
    left: 0;
    z-index: 2;
    width: 100%;
    height: 100%;
    background-color: ${props => props.theme.color[formElementThemes[props.$themeColor].checked.text]};
    border-radius: ${({ theme }) => (theme.isBorderRadiusDisabled ? 0 : '99999px')};
    transition-delay: 0.1s;
    transform: scale(0);
  }

  &::after {
    top: -25%;
    left: -25%;
    z-index: 1;
    width: 150%;
    height: 150%;
    background-color: ${props => props.theme.color[formElementThemes[props.$themeColor].checked.normal]};
    border-radius: ${({ theme }) => (theme.isBorderRadiusDisabled ? 0 : '99999px')};
    transform: scale(0);
  }

  ${props =>
    props.$isChecked &&
    css`
      &::before {
        opacity: 1;
        transform: scale(0.45);
      }

      &::after {
        opacity: 1;
        transform: scale(1);
      }
    `};

  &:disabled {
    cursor: not-allowed;
    background-color: ${props => props.theme.color[formElementThemes[props.$themeColor].border.disabled]} !important;

    &::before {
      background-color: ${props => props.theme.color[formElementThemes[props.$themeColor].checked.disabled]} !important;
    }

    &::after {
      background-color: ${props => props.theme.color[formElementThemes[props.$themeColor].border.disabled]} !important;
    }
  }
`;

export const ChildrenContainer = styled(StyledTypo.Typography)`
  margin: 1px 0 0;
`;
